import { safeParse, safeParseNullDefault } from 'shouldve-been-js';

class ObservationChapter {

    private _chapterId: string;
    private _ruleSetId: string;
    private _chapterNo: string;
    private _chapterName: string;
    private _sortNumber: number;
    private _status: string;

    public constructor(chapterId: string, ruleSetId: string, chapterNo: string, chapterName: string, sortNumber: number, status: string) {

        this._chapterId = chapterId;
        this._ruleSetId = ruleSetId;
        this._chapterNo = chapterNo;
        this._chapterName = chapterName;
        this._sortNumber = sortNumber;
        this._status = status;
    }

    public get chapterId(): string {
        return this._chapterId;
    }

    public set chapterId(value: string) {
        this._chapterId = value;
    }

    public get ruleSetId(): string {
        return this._ruleSetId;
    }

    public set ruleSetId(value: string) {
        this._ruleSetId = value;
    }

    public get chapterNo(): string {
        return this._chapterNo;
    }

    public set chapterNo(value: string) {
        this._chapterNo = value;
    }

    public get chapterName(): string {
        return this._chapterName;
    }

    public set chapterName(value: string) {
        this._chapterName = value;
    }

    public get sortNumber(): number {
        return this._sortNumber;
    }

    public set sortNumber(value: number) {
        this._sortNumber = value;
    }

    public get status(): string {
        return this._status;
    }

    public set status(value: string) {
        this._status = value;
    }

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
    public static fromJson(json: any): ObservationChapter | null {

        const chapterId: string | null = safeParseNullDefault<string>(json?.chapterId, '');
        const rulesetId: string | null = safeParseNullDefault<string>(json?.ruleSetId, '');
        const chapterNo: string = safeParse<string>(json?.chapterNo, '');
        const chapterName: string = safeParse<string>(json?.chapterName, '');
        const sortNumber: number = safeParse<number>(json?.sortNumber, 0);
        const status: string | null = safeParseNullDefault<string>(json?.status, '');
        
        if (chapterId === null || rulesetId === null || status === null || chapterId === '' || rulesetId === '') {
            return null;
        }

        return new ObservationChapter(chapterId, rulesetId, chapterNo, chapterName, sortNumber, status);
    }

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
    public static fromIndexedDB(object: any): ObservationChapter | null {

        const chapterId: string | null = safeParseNullDefault<string>(object?._chapterId, '');
        const rulesetId: string | null = safeParseNullDefault<string>(object?._ruleSetId, '');
        const chapterNo: string = safeParse<string>(object?._chapterNo, '');
        const chapterName: string = safeParse<string>(object?._chapterName, '');
        const sortNumber: number = safeParse<number>(object?._sortNumber, 0);
        const status: string | null = safeParseNullDefault<string>(object?._status, '');
        
        if (chapterId === null || rulesetId === null || status === null || chapterId === '' || rulesetId === '') {
            return null;
        }

        return new ObservationChapter(chapterId, rulesetId, chapterNo, chapterName, sortNumber, status);
    }
}

export default ObservationChapter;